<template>
  <div class="tags-comp">
    <div class="list ant-list ant-list-split">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="ant-list-item">
            <div class="ant-list-item-meta">
              <div class="ant-list-item-meta-content">
                <h4 class="ant-list-item-meta-title">
                  <a-input
                    v-model="newItem"
                    :placeholder="$t('add-tag')"
                    allowClear
                    @pressEnter="onAdd()"
                  />
                </h4>
              </div>
            </div>
            <ul class="ant-list-item-action">
              <li>
                <a-button
                  :disabled="!newItem"
                  v-if="!isDesktop"
                  @click="onAdd()"
                  type="primary"
                  shape="circle"
                  icon="plus"
                ></a-button>
                <a-button
                  :disabled="!newItem"
                  v-if="isDesktop"
                  @click="onAdd()"
                  type="primary"
                  icon="plus"
                >{{$t('add')}}</a-button>
              </li>
            </ul>
          </div>
          <div class="ant-list-item" v-for="(item,index) in items" :key="index">
            <div class="ant-list-item-meta">
              <div class="ant-list-item-meta-content">
                <h4 class="ant-list-item-meta-title">
                  <h3 v-if="!item.isEditmode" slot="title">{{item.name}}</h3>
                  <a-input
                    v-if="item.isEditmode"
                    :defaultValue="item.name"
                    @pressEnter="onSave(item,index)"
                    @change="onTextChange(item,$event.target.value, index)"
                    :placeholder="$t('rename-tag')"
                  />
                </h4>
              </div>
            </div>
            <ul v-if="item.isEditmode" class="ant-list-item-action">
              <li>
                <a-button
                  v-if="!isDesktop"
                  @click="onSave(item,index)"
                  type="primary"
                  shape="circle"
                  icon="save"
                ></a-button>
                <a-button
                  v-if="isDesktop"
                  @click="onSave(item,index)"
                  type="primary"
                  icon="save"
                >{{$t('add')}}</a-button>
              </li>
              <li>
                <a-button v-if="!isDesktop" @click="onCancel(item,index)" icon="close"></a-button>
                <a-button
                  v-if="isDesktop"
                  @click="onCancel(item,index)"
                  icon="close"
                >{{$t('cancel')}}</a-button>
              </li>
            </ul>
            <ul v-if="!item.isEditmode" class="ant-list-item-action">
              <li>
                <a-button v-if="!isDesktop" @click="onEdit(item,index)" type="primary" icon="edit"></a-button>
                <a-button
                  v-if="isDesktop"
                  @click="onEdit(item,index)"
                  type="primary"
                  icon="edit"
                >{{$t('edit')}}</a-button>
              </li>
              <li>
                <a-button
                  v-if="!isDesktop"
                  @click="onDelete(item,index)"
                  type="primary"
                  icon="delete"
                ></a-button>
                <a-button
                  v-if="isDesktop"
                  @click="onDelete(item,index)"
                  type="primary"
                  icon="delete"
                >{{$t('delete')}}</a-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TAGS_PAGINATION, TAGS } from "../store/constants";

export default {
  name: "Tags",
  data() {
    return {
      isDesktop: null,
      items: [],
      newItem: ""
    };
  },
  computed: {
    ...mapState({
      tags: state => state.tags[TAGS],
      pagination: state => state.tags[TAGS_PAGINATION]
    })
  },
  watch: {
    tags(newV, oldV) {
      this.items = this.tags.map(d => ({
        id: d.id,
        isEditmode: !!d.isEditmode,
        name: d.name,
        oldName: d.oldName
      }));
    }
  },
  methods: {
    ...mapActions({
      fetchTags: "tags/fetchTags",
      validateTag: "tags/validateTag",
      saveTag: "tags/saveTag",
      deleteTag: "tags/deleteTag"
    }),
    onAdd() {
      this.validateTag(this.newItem)
        .then(size => {
          if (!size) {
            this.saveTag({ name: this.newItem });
            this.newItem = "";
          } else {
            this.newItem = "";
            this.$notification.warning({
              message: "This tag is already added",
              placement: "bottomLeft"
            });
          }
        })
        .catch(error => {
          console.log("Error getting documents: ", error);
        });
    },
    onSave(d, index) {
      d.isEditmode = false;
      delete d.oldName;
      // self.$set(self.items, index, d);
      this.saveTag({ name: d.name, id: d.id });
    },
    onDelete(d, index) {
      this.deleteTag(d.id);
    },
    onCancel(d, index) {
      d.isEditmode = false;
      d.name = d.oldName;
      this.$set(this.items, index, d);
    },
    onTextChange(d, value, index) {
      d.name = value;
      this.$set(this.items, index, d);
    },
    onEdit(d, index) {
      d.isEditmode = true;
      d.oldName = d.name;
      this.$set(this.items, index, d);
    }
  },
  mounted() {
    this.isDesktop = window.innerWidth > 640;
  },
  created() {
    this.fetchTags({ page: 1, limit: 2000 });
  }
};
</script>

<style scoped lang="less">
@import "../styles/variables.less";

.tags-comp {
  margin-top: -32px;
  background: #f0f2f5;
  border: solid 1px #e8e8e8;
  padding: 16px 0;
  border-radius: 0px 16px 16px 16px;
}
h3 {
  margin-top: 6px;
}
.button-row {
  width: 100%;
  text-align: right;
  margin-top: @spacing*2;
}
.ant-list-item {
  padding: 12px 16px;
}
</style>
